import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgErrorInfo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.99995 5.33334V8.66667M7.99995 10.6667H8.00662M5.8983 13.7735H10.1016C10.5503 13.7735 10.7747 13.7735 10.9755 13.7082C11.1532 13.6505 11.3168 13.5561 11.4557 13.431C11.6126 13.2897 11.7248 13.0954 11.9491 12.7068L14.0508 9.06667C14.2751 8.67808 14.3873 8.48378 14.4312 8.27722C14.4701 8.09445 14.4701 7.90556 14.4312 7.72279C14.3873 7.51622 14.2751 7.32193 14.0508 6.93334L11.9491 3.29317C11.7248 2.90458 11.6126 2.71028 11.4557 2.56898C11.3168 2.44395 11.1532 2.3495 10.9755 2.29176C10.7747 2.2265 10.5503 2.2265 10.1016 2.2265H5.8983C5.44959 2.2265 5.22524 2.2265 5.02439 2.29176C4.84669 2.3495 4.6831 2.44395 4.54424 2.56898C4.38731 2.71028 4.27513 2.90458 4.05078 3.29317L1.94912 6.93334C1.72477 7.32193 1.61259 7.51622 1.56869 7.72279C1.52984 7.90556 1.52984 8.09445 1.56869 8.27722C1.61259 8.48378 1.72477 8.67808 1.94912 9.06667L4.05078 12.7068C4.27513 13.0954 4.38731 13.2897 4.54424 13.431C4.6831 13.5561 4.84669 13.6505 5.02439 13.7082C5.22524 13.7735 5.44959 13.7735 5.8983 13.7735Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgErrorInfo;
